<template>
  <SSection :desktop-full="true" :title="t('views.cottage.errorSection.title')">
    <UButton
      color="neutral"
      variant="subtle"
      size="sm"
      :label="t('views.cottage.errorSection.contact')"
      class="mt-3 mb-4"
      :to="routes().help()"
      external
      rel="nofollow"
      target="_blank"
    />
  </SSection>
</template>
